import React from 'react';
import Navbar from '../Navbar';
import Footer from '../Footer';
import SEO from '../SEO';
import MarketplaceHero from './MarketplaceHero';
import MarketplaceFeatures from './MarketplaceFeatures';
import VendorIntegrations from './VendorIntegrations';
import MarketplaceBenefits from './MarketplaceBenefits';
import MarketplaceFAQ from './MarketplaceFAQ';
import CTA from '../CTA';

const CloudMarketplacePage = () => {
  return (
    <div className="min-h-screen">
      <SEO
        title="Cloud Marketplace · Plataforma B2B de suscripciones cloud"
        description="Marketplace cloud con Microsoft CSP, Azure, AWS, Acronis y más. Autogestión para clientes, facturación multi-divisa y catálogo publicable con márgenes configurables."
        keywords="cloud marketplace, Microsoft CSP, Azure marketplace, AWS reseller, Acronis"
        canonical="/cloud-marketplace"
      />
      <Navbar />
      <MarketplaceHero />
      <MarketplaceFeatures />
      <VendorIntegrations />
      <MarketplaceBenefits />
      <MarketplaceFAQ />
      <CTA />
      <Footer />
    </div>
  );
};

export default CloudMarketplacePage;
